import React, { useContext } from 'react';
import { FilterTagStyled, IconClose } from './Styled';
import { context } from '../../../context';
import { useHandleFilter } from '../../../hooks/useHandleFilter';

interface FilterTagProps {
  rating?: string | null;
  fontSize?: number;
  onClick?: () => void;
}

const FilterTag: React.FC<FilterTagProps> = (props: FilterTagProps) => {
  const { fontSize = 16 } = props;
  const { queryParam, dispatchMetrics } = useContext(context);
  const { handleFilter } = useHandleFilter();
  const metric = () => {
    handleFilter({ rating: [] });
    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'fechar-filtro',
    });
  };

  if (!queryParam?.rating?.length) {
    return <></>;
  }
  return (
    <FilterTagStyled fontSize={fontSize} onClick={metric}>
      {`${queryParam?.rating[0]} estrela${queryParam?.rating[0] == 1 ? '' : 's'}`}
      <IconClose />
    </FilterTagStyled>
  );
};

FilterTag.defaultProps = {
  rating: null,
};

export default FilterTag;
export { FilterTag };
